var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsRoadmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78847 5.2334C7.97973 5.2334 8.13515 5.38882 8.13515 5.58008C8.13496 5.75226 8.00778 5.8985 7.8373 5.92285L6.34316 6.13574C5.6192 6.23916 5.51 7.24027 6.19472 7.49707L11.7445 9.75781C13.1695 10.3384 13.4451 12.237 12.2435 13.1982C11.8862 13.4841 11.4424 13.6396 10.9848 13.6396H5.34023C4.59724 13.6396 4.5176 12.5558 5.25234 12.4473C6.31184 12.2915 6.65158 10.9302 5.78944 10.2949L3.77577 8.81152C2.83709 8.11986 2.73358 6.7542 3.558 5.92969C3.80219 5.6855 4.10872 5.51247 4.44374 5.42871L4.82655 5.33301C5.09086 5.26693 5.36271 5.2334 5.63515 5.2334H7.78847ZM10.3978 2C11.9973 2 13.0112 3.71474 12.2406 5.11621L10.5795 8.13672C10.5008 8.27975 10.2949 8.27975 10.2162 8.13672L8.55507 5.11621C7.78463 3.7148 8.79855 2.0001 10.3978 2Z",
    fill: "#4C5E6E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3977,
    cy: 4.26358,
    r: 0.969998,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsRoadmap);
export default __webpack_public_path__ + "static/media/icons-roadmap.7f7a8596.svg";
export { ForwardRef as ReactComponent };